import { render, staticRenderFns } from "./family-list.vue?vue&type=template&id=5786a876&scoped=true"
import script from "./family-list.vue?vue&type=script&lang=ts"
export * from "./family-list.vue?vue&type=script&lang=ts"
import style0 from "./family-list.vue?vue&type=style&index=0&id=5786a876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786a876",
  null
  
)

export default component.exports